import React, { Component } from 'react';
import styled from 'styled-components';

import Notice from '../../../../web/components/Notice';
import LabelledTextInput from '../../../../web/components/LabelledTextInput';
import Checkbox from '../Account/components/Checkbox';

export default class Contact extends Component {
  componentDidMount() {
    /* eslint-disable-next-line */
		window.amplitude.getInstance().logEvent('Overview Next button Click');
  }
  render() {
    const { contactFields, shopDetailFields } = this.props.fields;

    return (
      <div style={{ backgroundColor: 'none', width: 965 }}>
        <div style={{ width: 965, margin: 25, paddingTop: 25, color: '#505d68' }}>
          Please tell us how we can contact you...
        </div>
        <InputContainer>
          {contactFields.map((field, key) => (
            <Column
              key={key}
            >
              <LabelledTextInput
                key={key}
                placeHolder={field.placeHolder}
                name={field.name}
                type="text"
                value={this.props.data[field.name]}
                onChange={this.props.onChange(field.name)}
              />
              { this.props.errors[field.name] ? (
                <div style={{ marginTop: 5 }}>
                  <Notice
                    color="red"
                    text={`Please enter a valid value`}
                    width="750"
                  />
                </div>
              ) : null }
            </Column>
          ))}
        </InputContainer>
        <div style={{ width: 965, margin: 25, paddingTop: 25, color: '#505d68' }}>
          And your shop details...
        </div>
        <InputContainer>
          {shopDetailFields.map((field, key) => (
            <Column
              key={key}
            >
              <LabelledTextInput
                placeHolder={field.placeHolder}
                name={field.name}
                type="text"
                value={this.props.data[field.name]}
                onChange={this.props.onChange(field.name)}
              />
              { this.props.errors[field.name] ? (
                <div style={{ marginTop: 5 }}>
                  <Notice
                    color="red"
                    text={`Please enter a valid value`}
                    width="750"
                  />
                </div>
              ) : null }
            </Column>
          ))}
          <Column style={{ width: '946px' }}>
            <Checkbox
              type="checkbox"
              name="isLicensed"
              label="test"
              value={this.props.data.licensedPostOffice}
              checked={this.props.data.licensedPostOffice}
              onClick={this.props.onChange('licensedPostOffice')}
              style={{ width: '20px' }}
            />
            <span
              style={{
                color: '#505d68',
                fontFamily: '"Karla", sans-serif',
                fontSize: '16px',
              }}
            >I am a Licensed Post Office (LPO)</span>
          </Column>
        </InputContainer>
      </div>
    )
  }
}

const InputContainer = styled.div`
	display: flex;
	width: 946px;
	justify-content: space-between;
	margin: 24px;
	flex-wrap: wrap;
`;

const Column = styled.div`
	width: 465px;
	margin-bottom: 20px;
`;



// WEBPACK FOOTER //
// ./client/redesign/signup/Main/pages/Contact/index.js